export default "__VITE_ASSET__cb20fedb__"